import { head, last, get } from 'lodash';
import moment from '~/_moment';
import { PressureActionTypes } from '~/actions/pressure';

const initialState = {
  date: moment().format('YYYY-MM-DD'),
  startTime: '00:00',
  endTime: moment().format('HH:mm'),
  data: null,
  isLoading: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PressureActionTypes.LOAD_PRESSURE:
      if (action.pressure_data && action.pressure_data.length) {
        let totalRain = 0;
        return {
          ...state,
          isLoading: false,
          date: moment(get(head(action.pressure_data), ['time'])).format('YYYY-MM-DD'),
          startTime: moment(get(head(action.pressure_data), ['time'])).format('HH:mm'),
          endTime: moment(get(last(action.pressure_data), ['time'])).format('HH:mm'),
          data: action.pressure_data.map((item) => {
            const { time, rain } = item;
            totalRain += rain;
            return {
              time,
              rain: Number(rain.toFixed(2)),
              totalRain: Number(totalRain.toFixed(2)),
            };
          }),
        };
      }

      return {
        ...state,
        data: null,
        isLoading: false,
      };

    case PressureActionTypes.RESET_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/reducers/rain.js